import { render } from "./TestItem.vue?vue&type=template&id=55c8e080"
import script from "./TestItem.vue?vue&type=script&lang=js"
export * from "./TestItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__